export default {
  token:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJGaXJzdE5hbWUiOiLQnNCw0LrRgdC40LwiLCJNaWRkbGVOYW1lIjoi0JjQs9C-0YDQtdCy0LjRhyIsIkxhc3ROYW1lIjoi0JrQsNC50LPQvtGA0L7QtNGG0LXQsiIsIlVzZXJJZCI6IjYiLCJTbmlscyI6IjQ4NzUwNjAzODE1IiwibmJmIjoxNTk4ODg3MjY1LCJleHAiOjE2MDY2NjMyNjUsImlhdCI6MTU5ODg4NzI2NX0.6IHvQfqThrIZA1aW5OTsNHaFGsDiz5mLkBwoHhoPMSI',
};
